import React, { useEffect } from "react";
import OngoingProjectCard from "./components/OngoingProjectCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchOngoingJobsForVendor } from "../../../redux/slices/vendorJobSlice";

const OngoingJobs = () => {
  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  useEffect(() => {
    if (vendorId) {
      dispatch(fetchOngoingJobsForVendor(vendorId));
    }
  }, [vendorId, dispatch]);
  return (
    <div>
      <OngoingProjectCard />
    </div>
  );
};

export default OngoingJobs;
